import { observable, action } from 'mobx';

// eslint-disable-next-line @typescript-eslint/ban-types
export class ConfigStore<T extends Object> {
    @observable public config: T;

    public breakpoints: Theme.IBreakpoints = {
        desktop: 768,
        largeScreen: 1024,
        extraLargeScreen: 1200
    };

    constructor(config: T) {
        this.updateConfig(config);
        this.exposeConfig();
    }

    @action
    public updateConfig = (config: T) => {
        // eslint-disable-next-line prefer-object-spread
        this.config = Object.assign({}, this.config, config);
    };
    public exposeConfig = () => {
        Object.keys(this.config).forEach(k => {
            if (!(k in this)) {
                Object.defineProperty(this, k, {
                    get: function () {
                        return this.config[k];
                    }
                });
            }
        });
    };
}
